module.exports = __webpack_public_path__ + "static/media/Home.bfd1e7fd.png";